import { common } from '@/utils/api/apis'

// 全局通用数据模块
export default {
  namespaced: true,
  state: {
    commonData: null
  },
  mutations: {
    SET_COMMON_DATA(state, data) {
      state.commonData = data
    }
  },
  actions: {
    async fetchCommonData({ commit }) {
      try {
        const { data } = await common()
        commit('SET_COMMON_DATA', data)
        return data
      } catch (e) {
        throw e
      }
    }
  },
  getters: {
    getCommonData: state => state.commonData
  }
} 


// WEBPACK FOOTER //
// ./src/store/modules/common.js